import { render, staticRenderFns } from "./commonDetails.vue?vue&type=template&id=0b451610&scoped=true&"
import script from "./commonDetails.vue?vue&type=script&lang=js&"
export * from "./commonDetails.vue?vue&type=script&lang=js&"
import style0 from "./commonDetails.vue?vue&type=style&index=0&id=0b451610&prod&scoped=true&lang=css&"
import style1 from "./commonDetails.vue?vue&type=style&index=1&id=0b451610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b451610",
  null
  
)

export default component.exports